import curry from 'lodash/fp/curry'
import memoize from 'lodash/fp/memoize'
import { compile } from 'path-to-regexp'

const memoizedCompile = memoize(compile)

export const compilePath = curry((path, params) => {
  const toPath = memoizedCompile(path)
  return toPath(params)
})
